/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/components/comment/index.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import * as React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
const Comment = ({ actions, author, avatar, children, className, content, prefixCls: customizePrefixCls, datetime, ...otherProps }) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const renderNested = (prefixCls, nestedChildren) => (React.createElement("div", { className: classNames(`${prefixCls}-nested`) }, nestedChildren));
    const prefixCls = getPrefixCls('comment', customizePrefixCls);
    const avatarDom = avatar ? (React.createElement("div", { className: `${prefixCls}-avatar` }, typeof avatar === 'string' ? React.createElement("img", { src: avatar, alt: 'comment-avatar' }) : avatar)) : null;
    const actionDom = actions && actions.length ? (React.createElement("ul", { className: `${prefixCls}-actions` }, actions.map((action, index) => (React.createElement("li", { key: `action-${index}` }, action) // eslint-disable-line react/no-array-index-key
    )))) : null;
    const authorContent = (author || datetime) && (React.createElement("div", { className: `${prefixCls}-content-author` },
        author && React.createElement("span", { className: `${prefixCls}-content-author-name` }, author),
        datetime && React.createElement("span", { className: `${prefixCls}-content-author-time` }, datetime)));
    const contentDom = (React.createElement("div", { className: `${prefixCls}-content` },
        authorContent,
        React.createElement("div", { className: `${prefixCls}-content-detail` }, content),
        actionDom));
    const cls = classNames(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className);
    return (React.createElement("div", { ...otherProps, className: cls },
        React.createElement("div", { className: `${prefixCls}-inner` },
            avatarDom,
            contentDom),
        children ? renderNested(prefixCls, children) : null));
};
// export default withConfigProvider(Comment);
export default Comment;
